module.exports = __webpack_public_path__ + "assets/0286ae7ba12b4311a6b1266bbd1b12f8.png";